import MetaData from "@/components/seo/MetaData";
import { PHONE_NUMBER } from "@/utils/constants/supportInfo";

function ReturnPolicy() {
  const pageUrl = `${process.env.NEXT_PUBLIC_SITE_ABSOLUTE_URL}/return-and-refund-policy`;

  return (
    <>
      <MetaData url={pageUrl} />
      <div className="px-[2rem] lg:px-[7.5rem] pt-[4rem] pb-[7.5rem]">
        <h1 className="text-[ #0A101A] font-semibold text-[2.625rem]">
          Return Policy
        </h1>

        <p className="text-[#1F2A3B] text-[1rem] mt-[2.25rem]">
          Last updated: 10 January, 2024
        </p>

        <p className="my-[2rem] text-[#1F2A3B]">
          When you receive a product, it is important to thoroughly inspect it
          in front of the delivery personnel. This is to ensure that the product
          you have received is of good quality and meets your expectations.
        </p>

        <p className="my-[2rem] text-[#1F2A3B]">
          During the inspection process, you should carefully examine the
          product for any defects or signs of expiration. If you notice any
          issues with the product, it is important to bring them to the
          attention of the delivery personnel immediately. This will allow you
          to reject the product on the spot and have it exchanged or returned.
        </p>

        <p className="my-[2rem] text-[#1F2A3B]">
          It is important to understand that if you fail to reject the product
          in the presence of the delivery personnel, you will be deemed to have
          accepted it irrevocably. This means that you will lose your right to
          return or exchange the product for any reason.
        </p>

        <p className="my-[2rem] text-[#1F2A3B]">
          However, if the product that was delivered to you is not the correct
          product, you can inform us immediately. We will be happy to exchange
          it for you as long as it has not been used and the manufacturing seal
          is still intact. This will ensure that you receive the correct product
          and are satisfied with your purchase.
        </p>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">Refund policy</p>
          <p>
            In the unlikely event of a delivery failure on our part, we want to
            assure you that your payment will be fully refunded within 7 working
            days. If you receive the product and wish to cancel the order in the
            presence of the delivery personnel, there will be a charge for the
            delivery fee, which you will need to pay. The product will need to
            be returned in its original condition and packaging. If you have
            made an advance payment for the product, rest assured that your
            payment will be refunded within 7 working days after the
            cancellation or return of the order. To know more call our customer
            support at
            <span className="ml-1">{PHONE_NUMBER.CUSTOMER_SUPPORT}</span>
          </p>
        </div>

        <div className="space-y-[1.5rem] mt-[2rem]">
          <p className="text-[#1F2A3B] font-bold text-xl">Exchange policy</p>
          <p>
            Exchange of products will be possible following the fulfillment of
            certain conditions. Firstly, the product must be in its original,
            intact, and unused condition. This means that the product must not
            have been opened or used in any way. Additionally, the manufacturing
            seal must still be intact. This helps to ensure that the product
            remains in the same condition it was in, when it was first delivered
            to you. Secondly, the exchangeable product must be available in our
            stock. To ensure that we are able to provide you with the product
            you need, it is important that the product is still available for
            exchange. Our customer service team will be able to assist you with
            determining the availability of the product you wish to exchange.
            Finally, you will be responsible for paying the delivery charge for
            the exchange. This helps to cover the cost of shipping the new
            product to you.
          </p>
          <p>
            AmarPet reserves the right to refuse any return or exchange of
            product that does not meet the conditions outlined in this policy.
          </p>
        </div>
      </div>
    </>
  );
}

export default ReturnPolicy;
